import React from 'react';

const SUB_TITLES = [
  'Continue building intelligent workflows',
  'Pick up where you left off',
  'Ready to automate something?',
  'What will you build today?',
  "Let's build something great",
  'Time to automate the boring stuff',
  'Your agents are waiting',
  'Ready to ship?',
  'What needs automating today?',
  "Let's make work easier",
];

const MORNING_GREETINGS = [
  'Good morning ☀️',
  'Morning! ☀️',
  'Rise and automate ☀️',
];

const AFTERNOON_GREETINGS = ['Good afternoon 😊'];

const EVENING_GREETINGS = [
  'Good evening 🌙',
  'Still here? 🌙',
  'Working late? 🌙',
];

const getTimeOfDayGreeting = (): string => {
  const hour = new Date().getHours();
  const greetings =
    hour < 12
      ? MORNING_GREETINGS
      : hour < 18
      ? AFTERNOON_GREETINGS
      : EVENING_GREETINGS;

  return greetings[Math.floor(Math.random() * greetings.length)]!;
};

export const HomepageGreeting: React.FC = () => {
  // Memoize the greeting and subtitle so they don't change on every render
  const greeting = React.useMemo(() => getTimeOfDayGreeting(), []);
  const subtitle = React.useMemo(
    () => SUB_TITLES[Math.floor(Math.random() * SUB_TITLES.length)],
    []
  );

  return (
    <>
      <h1 className="text-5xl font-bold text-slate-900 mb-4">{greeting}</h1>
      <p className="text-xl text-slate-600 mb-8">{subtitle}</p>
    </>
  );
};
